// const url = '/business/yhPlanReport/'
const url = '/business/yhPlanReport/'
const url1 = '/business/yhDailyPlan/'
export default {
  insertYhPlanReport: url + 'insertYhPlanReport',
  updateYhPlanReport: url + 'updateYhPlanReport',
  updateStatusWithdraw: url + 'updateStatusWithdraw',
  selectYhPlanReportByReportId: url + 'selectYhPlanReportByReportId',
  selectYhPlanReportByPage: url + 'selectYhPlanReportByPage',
  importYhPlanReport: url + 'importYhPlanReport',
  deleteYhPlanReport: url + 'deleteYhPlanReport',
  // 新
  insertYhDailyPlan: url1 + 'insertYhDailyPlan',
  updateYhDailyPlan: url1 + 'updateYhDailyPlan',
  deleteYhDailyPlan: url1 + 'deleteYhDailyPlan',
  selectYhDailyPlanByPlanId: url1 + 'selectYhDailyPlanByPlanId',
  selectYhDailyPlanByPage: url1 + 'selectYhDailyPlanByPage',
  selectUpYhDailyPlanByProjectId: url1 + 'selectUpYhDailyPlanByProjectId',
  selectYhDailyPlanByList: url1 + 'selectYhDailyPlanByList',
  selectYhDailyWorkByList: url1 + 'selectYhDailyWorkByList'
}
